import { render, staticRenderFns } from "./BePrivacyPolicyModal.vue?vue&type=template&id=69ef5501&scoped=true"
import script from "./BePrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./BePrivacyPolicyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef5501",
  null
  
)

export default component.exports